import { render, staticRenderFns } from "./add-show-options.vue?vue&type=template&id=31a10808"
import script from "./add-show-options.vue?vue&type=script&lang=js"
export * from "./add-show-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports